import React, { useMemo } from 'react'
import { Merchant, QueryOptions, useSearchData } from '../utils/searchData'
import { ErrorPage } from './ErrorPage'
import { MerchantCard } from './MerchantCard'

interface SearchResultsProps {
  options: QueryOptions
}

type MerchantPredicate = (merchant: Merchant) => boolean

export function SearchResults({ options }: SearchResultsProps) {
  const { data } = useSearchData()
  const { merchants, categoryMap, priceRange } = data!

  const filtered = useMemo(() => {
    const {
      searchQuery,
      category: categoryName,
      province,
      price,
      subcategory,
    } = options
    const category = categoryName && categoryMap[categoryName]
    const predicates: MerchantPredicate[] = []

    if (searchQuery) {
      const searchQueryLowerCase = searchQuery.toLowerCase()
      predicates.push((merchant) =>
        merchant.shopNameTH.toLowerCase().includes(searchQueryLowerCase)
      )
    }
    if (category) {
      predicates.push((merchant) =>
        category.subcategorySet.has(merchant.subcategoryName)
      )
    }
    if (province) {
      predicates.push((merchant) => merchant.addressProvinceName === province)
    }
    if (price) {
      predicates.push((merchant) => merchant.priceLevel === parseInt(price))
    }
    if (subcategory) {
      predicates.push((merchant) => merchant.subcategoryName === subcategory)
    }

    return merchants.filter((merchant) =>
      predicates.every((predicate) => predicate(merchant))
    )
  }, [merchants, categoryMap, options])

  if (filtered.length === 0) {
    return (
      <ErrorPage
        title="ไม่พบสถานที่ที่คุณกำลังหา"
        description="ร้านค้าที่ท่านค้นหาอาจไม่ได้เข้าร่วมโครงการ คนละครึ่ง"
      />
    )
  }

  return (
    <div style={{ flex: 1 }}>
      {filtered.map((merchant) => (
        <MerchantCard
          key={merchant.shopNameTH}
          merchant={merchant}
          priceRange={priceRange.length}
        />
      ))}
    </div>
  )
}
